export const getDefaultState = () => {
  return {
    isAuthenticated:false,
    ingredients:[],
    posts: [],
    ingredientsLoading: true,
    postsLoading: true,
    postToEdit:null,
    postIsSaved: false,
    loadingPostToEdit: false,
    allowedToEdit:false,
    postsCategories: [],
    postsOptions: {},
    totalPosts:0,
    dialog:{
      active: false,
      title: '',
      body: '',
      resolve: null,
      reject: null,
      advancedDialog:false,
    },
    dialogDefault:{
      active: false,
      title: '',
      body: '',
      resolve: null,
      reject: null,
      advancedDialog: false,
    },
    charts:{
      viewsLastThirtyDays: [],
      viewsLastSevenDays:[],
      allTags:[]
    }
  }
}
